module.exports = __webpack_public_path__ + "img/mysql.0fd0399a.svg";